import Script from 'next/script';

export function GoogleTag(): JSX.Element {
	const gtagId = process.env.NEXT_PUBLIC_GTAG_ID;

	if (gtagId === 'G-0000000000') {
		return <></>;
	}

	return (
		<>
			<Script src={`https://www.googletagmanager.com/gtag/js?id=${gtagId}`} strategy="afterInteractive" />
			<Script id="google-analytics" strategy="afterInteractive">
				{`
					window.dataLayer = window.dataLayer || [];
					function gtag(){dataLayer.push(arguments);}
					gtag('js', new Date());

					gtag('config', '${gtagId}');
        `}
			</Script>
		</>
	);
}
